export const API_BASE_URL = "https://service.ludominga.com/";
